/* istanbul ignore file */

import { FormTemplate, DateInput, SubmitFormButton } from 'framework/form';
import workingHoursFiltersValidation from 'domain/finance/workingHours/List/workingHoursFiltersValidation';
import QuickFilters from 'domain/finance/workingHours/List/filter/QuickFiltersLayout';
import PreviousAndCurrentMonthsQuickFilter from 'domain/finance/workingHours/List/filter/PreviousAndCurrentMonthsQuickFilter';
import CurrentMonthQuickFilter from 'domain/finance/workingHours/List/filter/CurrentMonthQuickFilter';
import PreviousMonthQuickFilter from 'domain/finance/workingHours/List/filter/PreviousMonthQuickFilter';
import { LoadingFormLayout, FormRow } from 'framework/ui/layout';
import useWorkingHoursService from 'domain/finance/workingHours/shared/workingHoursService';
import { EmployeeInput } from 'domain/shared/employee';
import { ListHeader, ListPageLayout } from 'framework/list';
import { downloadFile } from 'framework/utils';

const WorkingHoursList = () => {
  const { getReport } = useWorkingHoursService();

  return (
    <>
      <ListPageLayout header={<ListHeader label="Working Hours" icon="fa-clock-o" />}>
        <FormTemplate
          submitFormFunc={data => getReport(data as any).then(resp => downloadFile(resp))}
          getValidationSchemaFunc={() => Promise.resolve(workingHoursFiltersValidation)}
          handleDirty={false}
        >
          <QuickFilters>
            <PreviousAndCurrentMonthsQuickFilter />
            <CurrentMonthQuickFilter />
            <PreviousMonthQuickFilter />
          </QuickFilters>

          <FormRow colXl={4}>
            <EmployeeInput source="employeeAlias" label="Worker name or ID" withContractors />
          </FormRow>
          <FormRow colXl={2}>
            <DateInput label="Period from" source="dateFrom" />
            <DateInput label="To" source="dateTo" />
          </FormRow>

          <SubmitFormButton sx={{ marginBottom: '10px' }}>Generate</SubmitFormButton>

          <LoadingFormLayout />
        </FormTemplate>
      </ListPageLayout>
    </>
  );
};

export default WorkingHoursList;
